import { Flex, Icon, Text } from '@clear/design-system'
import React from 'react'

export interface IConversionCouponInfo {
  fullWidth?: boolean
  conversionCouponInfo?: string
}

export const ConversionCouponInfo = ({
  fullWidth = false,
  conversionCouponInfo = '',
}: IConversionCouponInfo) => (
  <Flex
    borderRadius="0.25rem"
    background="#ABC994"
    marginTop="0.25rem"
    marginBottom="0.25rem"
    maxWidth="80%"
    minWidth={fullWidth ? '100%' : 0}
    padding="0.5rem"
    alignSelf="flex-start"
    justifyContent="left"
  >
    <Icon name="dollar-sign" />
    <Text
      data-testid="conversion-coupon-info"
      data-cy="conversion-coupon-info"
      alignSelf="center"
      color="neutralsTextBlack"
      overflow="auto"
    >
      {conversionCouponInfo}
    </Text>
  </Flex>
)
